"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const InputField_1 = __importDefault(require("../../forms/InputField"));
const Button_1 = __importDefault(require("../../forms/Button"));
const react_router_dom_1 = require("react-router-dom");
const api_1 = require("../../api");
const errorNotification_1 = require("../../errorNotification");
const react_helmet_1 = __importDefault(require("react-helmet"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
const moment_1 = __importDefault(require("moment/moment"));
const AddEdit = ({ history, match, ...props }) => {
    const { orderId } = match.params;
    const isAddMode = !orderId;
    const orderApi = new api_1.OrdersApi();
    let initialValues = {
        name: '',
        expires_at: null,
    };
    function onSubmit(values, { setErrors, setStatus, setSubmitting }) {
        setStatus();
        if (isAddMode) {
            create(values, setSubmitting, setErrors);
        }
        else {
            update(orderId, values, setSubmitting, setErrors);
        }
    }
    function create(fields, setSubmitting, setErrors) {
        orderApi.create(fields)
            .then(() => {
            (0, errorNotification_1.notify)('success', 'Bestellung erstellt!');
            history.push('.');
        })
            .catch((error) => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            setSubmitting(false);
        });
    }
    function update(id, fields, setSubmitting, setErrors) {
        orderApi.update(id, fields)
            .then(() => {
            (0, errorNotification_1.notify)('success', 'Bestellung aktualisiert!');
            history.push('..');
        })
            .catch(error => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors);
            }
            else {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            setSubmitting(false);
        });
    }
    return (react_1.default.createElement("div", { className: "container max-w-5xl" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, isAddMode ? 'Neue Bestellung' : 'Bestellung')),
        react_1.default.createElement("div", { className: "flex-1 min-w-0 my-4" },
            react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, isAddMode ? 'Neue Bestellung' : 'Bestellung')),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement("div", { className: "shadow sm:rounded-md sm:overflow-hidden" },
                react_1.default.createElement("div", { className: "bg-white py-6 px-4 sm:p-6" },
                    react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: onSubmit }, ({ values, isSubmitting, setFieldValue, errors }) => {
                        (0, react_1.useEffect)(() => {
                            if (!isAddMode) {
                                // get user and set form fields
                                orderApi.get(orderId).then((data) => {
                                    const { item } = data;
                                    setFieldValue('name', item.name);
                                    setFieldValue('expires_at', moment_1.default.utc(item.expires_at).toDate());
                                });
                            }
                        }, []);
                        let selectedDate = moment_1.default.utc(values.expires_at);
                        let isSelectedDateToday = selectedDate.isSame((0, moment_1.default)().utc(), 'day');
                        let isSelectedDateInFuture = selectedDate.isAfter(new Date(), 'day');
                        let currentMins = (0, moment_1.default)().minutes();
                        let currentHour = (0, moment_1.default)().hours();
                        // console.log(moment().format(),currentMins, currentHour)
                        // console.log('isToday', isSelectedDateToday);
                        // console.log('isAfter', isSelectedDateInFuture);
                        if (isSelectedDateInFuture) {
                            currentHour = 0;
                            currentMins = 0;
                        }
                        let minTime = new Date(new Date().setHours(currentHour, currentMins, 0, 0));
                        return (react_1.default.createElement(formik_1.Form, null,
                            react_1.default.createElement("div", { className: 'space-y-6' },
                                react_1.default.createElement(InputField_1.default, { name: "name", type: "text", label: "Name", placeholder: "Name" }),
                                react_1.default.createElement("div", { className: "space-y-1" },
                                    react_1.default.createElement("label", { htmlFor: 'expires_at', className: "block text-sm font-medium text-gray-700" }, "Bestelltermin"),
                                    react_1.default.createElement(react_datepicker_1.default, { selected: values.expires_at, dateFormat: "dd.MM.yyyy, HH:mm", showTimeSelect: true, excludeOutOfBoundsTimes: true, timeFormat: "HH:mm", name: 'expires_at', className: 'form-input', 
                                        // locale="de-DE"
                                        minDate: new Date(), minTime: minTime, maxTime: new Date(new Date().setHours(23, 59, 0, 0)), onChange: (date) => {
                                            setFieldValue('expires_at', date);
                                        } }),
                                    errors.expires_at ? react_1.default.createElement("p", { className: "mt-2 text-sm text-red-600", id: "email-error" }, errors.expires_at[0]) : ''),
                                react_1.default.createElement(Button_1.default, { type: "submit", size: 'md', disabled: isSubmitting }, "Speichern"),
                                react_1.default.createElement(react_router_dom_1.Link, { to: `/orders`, className: "ml-4 link-button --secondary" }, "Abbrechen"))));
                    }))))));
};
exports.default = AddEdit;
